import Spinners from "components/common/Spinners";
import React, { useEffect } from "react";
import { Container } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useSearchParams } from "react-router-dom";
import { validateAutoLogin } from "store/actions/authSlice";
import { showAlert } from "store/reducers/alertReducer";

const AutoRedirectUrl = () => {
  const { t } = useTranslation();
  document.title = t("Auto Redirect Url | Work Space");

  const { isLoading } = useSelector((state) => state.auth);

  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const token = searchParams.get("token");
  const dispatch = useDispatch();

  useEffect(() => {
    token && handleAutoLogin();
  }, [token]);

  const handleAutoLogin = () => {
    const payload = {
      token,
    };

    dispatch(validateAutoLogin(payload))
      .then((action) => {
        const { statusCode, success, message, data } = action?.payload;
        if (statusCode === 200 && success) {
          dispatch(showAlert({ text: message, type: "success" }));
          navigate(`/dashboards/overview`);
        } else {
          dispatch(showAlert({ text: message, type: "error" }));
          const { uuid } = data;
          if (uuid) {
            navigate(`/reset-new-password/${uuid}`);
          }
        }
      })
      .catch((err) => {});
  };

  return (
    <React.Fragment>
      <div className="page-content">
        {isLoading ? <Spinners /> : <Container fluid></Container>}
      </div>
    </React.Fragment>
  );
};

export default AutoRedirectUrl;
